import script from "./cycle-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./cycle-detail.vue?vue&type=script&setup=true&lang=js"

import "./cycle-detail.vue?vue&type=style&index=0&id=12ef159e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ef159e"]])

export default __exports__